import { RequestsMap as Map } from 'modules/stats/components/RequestsMap';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { WidgetSection } from '../WidgetSection';
import { requestsMapTranslation } from './translation';
import { useStats } from '../StatsProvider';

export const RequestsMap = () => {
  const { chainCallProtocol } = useChainSelectors();
  const { countries, countriesByTraffic, loading } = useStats();

  const { keys, t } = useTranslation(requestsMapTranslation);

  const isGRPC = chainCallProtocol === 'grpc';

  const data = isGRPC ? countriesByTraffic : countries;

  return (
    <WidgetSection title={t(keys.title)}>
      <Map countries={data} loading={loading} />
    </WidgetSection>
  );
};
